import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
  link: {
    marginRight: 20,
  },
}));

const SocialIcons = ({ facebookLink, whatsappLink, igLink }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {facebookLink ? (
        <a href={facebookLink} target="_blank" rel="noreferrer" className={classes.link}>
          <img src="/static/images/icon-facebook.svg" />
        </a>
      ) : null}
      {whatsappLink ? (
        <a href={whatsappLink} target="_blank" rel="noreferrer" className={classes.link}>
          <img src="/static/images/icon-whatsapp.svg" />
        </a>
      ) : null}
      {igLink ? (
        <a href={igLink} target="_blank" rel="noreferrer" className={classes.link}>
          <img src="/static/images/icon-instagram.svg" width="46" />
        </a>
      ) : null}
    </div>
  );
};

SocialIcons.propTypes = {
  facebookLink: PropTypes.string,
  whatsappLink: PropTypes.string,
  igLink: PropTypes.string,
};

export default SocialIcons;
